import type { RouterInputs } from "~/utils/api";

export type ResearchFilter = RouterInputs["research"]["list"]["filter"];
export type Slices = RouterInputs["research"]["list"]["filter"]["type"];
